import i18n from "./i18n";

export default {
	install(Vue, options) {
		Vue.prototype.$formatters = {
			formatCurrency(value, currency = "€", decimals = 2) {
				const digitsRE = /(\d{3})(?=\d)/g;
				value = parseFloat(value);
				if (!isFinite(value) || (!value && value !== 0)) return "";
				var stringified = Math.abs(value).toFixed(decimals);
				var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
				var i = _int.length % 3;
				var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? " " : "") : "";
				var _float = decimals ? stringified.slice(-1 - decimals) : "";
				var sign = value < 0 ? "- " : "";
				return sign + currency + " " + head + _int.slice(i).replace(digitsRE, "$1,") + _float;
			},
			backEndDateFormat: function (date) {
				return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
			},
			backEndDateWithoutTime: function (date) {
				if (date) {
					return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
				}
				return null;
			},
			backEndTimeWithoutDate: function (date) {
				if (date) {
					return moment(date, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
				}
				return null;
			},
			fileSize: function (bytes = 0) {
				let kb = bytes / 1024;
				if (kb < 1024) {
					return kb.toFixed(2) + " Kb";
				}
				let mb = kb / 1024;
				if (mb < 1024) {
					return mb.toFixed(2) + " Mb";
				}
				let gb = mb / 1024;
				if (gb < 1024) {
					return gb.toFixed(2) + " Gb";
				}
			},
			frontEndDateFormat: function (date) {
				let formatted = moment(date, "YYYY-MM-DD");
				if (formatted.isValid()) {
					return formatted.format("DD/MM/YYYY");
				}
				return null;
			},
			frontEndMonthFormat: function (date) {
				let formatted = moment(date, "YYYY-MM-DD");
				if (formatted.isValid()) {
					return formatted.format("MMMM YYYY");
				}
				return null;
			},
			formatDateTime: function (dateString, zone = null, h24mode = true) {
				if (zone != null) {
					return moment(dateString)
						.tz(zone ? zone : "Europe/Rome")
						.format(h24mode ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY hh:mm A");
				} else {
					return moment(dateString).format(h24mode ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY hh:mm A");
				}
			},
			frontendDateFromNumber: function (daynumber) {
				return i18n.t("global.days.d" + daynumber);
			},
			yesNo: function (value) {
				if (value == 1 || value == true) {
					return i18n.t("global.yes");
				}
				return i18n.t("global.no");
			},
			formatAddress(item) {
				let content = "";
				content += item.address;
				if (item.city) {
					content += "\n";
					if (item.postcode) {
						content += item.postcode + " ";
					}
					content += item.city;
					if (item.state) {
						content += " (";
						content += item.state;
						content += ")";
					}
				}
				return content;
			},
			pSBC: function (p, c0, c1, l) {
				let r,
					g,
					b,
					P,
					f,
					t,
					h,
					i = parseInt,
					m = Math.round,
					a = typeof c1 == "string";
				if (typeof p != "number" || p < -1 || p > 1 || typeof c0 != "string" || (c0[0] != "r" && c0[0] != "#") || (c1 && !a)) return null;
				if (!this.pSBCr)
					this.pSBCr = (d) => {
						let n = d.length,
							x = {};
						if (n > 9) {
							([r, g, b, a] = d = d.split(",")), (n = d.length);
							if (n < 3 || n > 4) return null;
							(x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))), (x.g = i(g)), (x.b = i(b)), (x.a = a ? parseFloat(a) : -1);
						} else {
							if (n == 8 || n == 6 || n < 4) return null;
							if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
							d = i(d.slice(1), 16);
							if (n == 9 || n == 5) (x.r = (d >> 24) & 255), (x.g = (d >> 16) & 255), (x.b = (d >> 8) & 255), (x.a = m((d & 255) / 0.255) / 1000);
							else (x.r = d >> 16), (x.g = (d >> 8) & 255), (x.b = d & 255), (x.a = -1);
						}
						return x;
					};
				(h = c0.length > 9), (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h), (f = this.pSBCr(c0)), (P = p < 0), (t = c1 && c1 != "c" ? this.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }), (p = P ? p * -1 : p), (P = 1 - p);
				if (!f || !t) return null;
				if (l) (r = m(P * f.r + p * t.r)), (g = m(P * f.g + p * t.g)), (b = m(P * f.b + p * t.b));
				else (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)), (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)), (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
				(a = f.a), (t = t.a), (f = a >= 0 || t >= 0), (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
				if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
				else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
			},
		};
	},
};
